import { Container } from "@mui/material";
import { FC } from "react";

import { HistoryManagement } from "../components";

export const History: FC = () => {
  return (
    <Container sx={{ flexGrow: 1 }}>
      <HistoryManagement />
    </Container>
  );
};
